<template v-if="authIsReady">
  <!-- Mobile experience: bare shell, MobileLayout supplies its own chrome -->
  <router-view v-if="isMobileLayout"/>

  <!-- Desktop / auth shell -->
  <div v-else class="h-screen flex flex-col bg-neutral-50 dark:bg-neutral-900">
    <Navbar v-if="user"/>

    <!-- View for authenticated users -->
    <div v-if="(user && userProfile)" class="flex-1 flex overflow-hidden">
      <SideNavbar class="flex-shrink-0"/>
      <main class="flex-1 overflow-y-auto">
        <div class="px-6 py-6">
          <div class="max-w-7xl mx-auto">
            <router-view/>
          </div>
        </div>
      </main>
    </div>

    <!-- View for unauthenticated users -->
    <div v-if="!user" class="flex-1 overflow-y-auto">
      <router-view/>
    </div>

    <Footer v-if="user"/>
    <ToastHost />
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue'
import Footer from './components/Footer.vue';
import SideNavbar from './components/SideNavbar.vue';
import ToastHost from './components/ToastHost.vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { computed } from '@vue/runtime-core';

export default{
  setup() {
    const store = useStore()
    const route = useRoute()

    return {
      user: computed(() => store.state.user),
      authIsReady: computed(() => store.state.authIsReady),
      userProfile: computed(() => store.state.userProfile),
      isMobileLayout: computed(() => route.meta.layout === 'mobile')
    }
  },
  components: { Navbar, Footer, SideNavbar, ToastHost }
}
</script>

<style>
  html, body {
    height: 100%;
  }
</style>
